import {any, compose, isNil, prop, sortBy, toLower} from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Checkbox, Header, Icon, Table} from 'semantic-ui-react';
import styled from 'styled-components';
import {retrieveSchoolUsers, toggleUserRole} from '../../api';
import MenuButton from '../../components/Button/MenuButton';
import {CharcoalContainer} from '../../components/Container/ContainerMix';
import {getSchoolProperty, getUserProperty, userHasRole} from '../../util/Session';

const FullHeightCharcoalContainer = styled(CharcoalContainer)`
  height: calc(100vh);
  overflow-y: auto;
  font-size: 10px !important;
`;

class SchoolUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      users: []
    };
  }

  componentDidMount() {
    const {router} = this.props;

    // Only allow admins to view this.  If not admin, gracefully redirect to dashboard
    const isAdmin = userHasRole('admin');
    if (!isAdmin) {
      router.push('/dashboard');
      return;
    }

    this.setState({isLoading: true});

    const schoolId = getSchoolProperty('id');
    return retrieveSchoolUsers(schoolId)
      .then(response => {
        this.setState({isLoading: false, users: response.data.users});
      });
  }

  userIsTeacher = (user) => any(usr => usr.role.name === 'staff', user.user_school_roles)

  toggleTeacherOrStudent = (userId) => {
    const {users} = this.state;
    const user = users.find(u => u.id === userId);
    if (isNil(user)) {
      return;
    }

    // if the user is currently a teacher - make them a student, if the user is currently a student - make them a teacher
    const newRoleName = this.userIsTeacher(user) ? 'student' : 'staff';
    return toggleUserRole(user.school.id, userId, newRoleName)
      .then(response => {
        const sorter = sortBy(compose(toLower, prop('first_name')));
        this.setState({
          isLoading: false,
          users: sorter(users.filter(u => u.id !== userId).concat(response.data))
        });
      });
  };

  render() {
    const {onClickSidebar} = this.props;
    const {isLoading, users} = this.state;

    const loggedInUserId = getUserProperty('id');

    return (
      <FullHeightCharcoalContainer>
        <MenuButton onClick={onClickSidebar}/>
        <Header as="h2" icon textAlign="center">
          <Icon name="users" circular/>
          <Header.Content>Staff & students</Header.Content>
        </Header>
        {
          isLoading ?
            <i aria-hidden="true" className="spinner loading icon"/> :
            (
              <Table sortable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      Name
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Email
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Team size
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Staff
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                {users.map(user => (
                  <Table.Body key={user.id}>
                    <Table.Row>
                      <Table.Cell>{user.first_name} {user.last_name}</Table.Cell>
                      <Table.Cell fixed>{user.email}</Table.Cell>
                      <Table.Cell fixed>{user.team_size}</Table.Cell>
                      <Table.Cell collapsing>
                        <Checkbox slider disabled={user.id === loggedInUserId} checked={this.userIsTeacher(user)} onChange={() => this.toggleTeacherOrStudent(user.id)}/>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                ))}
              </Table>
            )
        }

      </FullHeightCharcoalContainer>
    );
  }
}

SchoolUsers.propTypes = {
  onClickSidebar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(SchoolUsers);



// WEBPACK FOOTER //
// ./src/pages/Schools/SchoolUsers.js